import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Input,
  Button,
  Radio,
  DatePicker,
  Upload,
  Row,
  Col,
  Typography,
  Space,
  Modal,
  TimePicker,
  InputNumber,
  Card,
  Flex,
  Tooltip,
  message,
  Select,
  Tag
} from "antd";
import { UploadOutlined, PlusOutlined, EyeOutlined, CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import SuccessModal from './SuccessModal';
import api from '../../../api';
import dayjs from "dayjs";
import "./Events.css";
import { useNavigate } from "react-router-dom";

const { TextArea } = Input;
const { Title, Text } = Typography;
const { Option } = Select;

const Event = ({ visible, onClose, onSuccess, editdata, getEventData }) => {
  const [form] = Form.useForm();
  const [bannerPreview, setBannerPreview] = useState(null);
  const [bannerModalVisible, setBannerModalVisible] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [hostType, setHostType] = useState('1');
  const [priceTier, setPriceTier] = useState('free');
  const [customPrice, setCustomPrice] = useState('');
  const [bannerFileList, setBannerFileList] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [sponsorSection, setSponsorSection] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [eventType, setEventType] = useState('offline');
  const [availableSponsors, setAvailableSponsors] = useState([]);
  const hasInitialized = useRef(false);
  const navigate = useNavigate();


  const fetchSponsors = async () => {
    try {
      const requestData = {
        synceddatetime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        FormCode: "201",
        AppVersion: "1.0.0.0",
        ApiKey: "kavin",
        AppTypeNo: "3",
      };

      const res = await api.getSponsorCreation(requestData);


      if (res?.data?.status === "1" && Array.isArray(res.data.sponsor_data)) {
        setAvailableSponsors(res.data.sponsor_data);
      } else {
        messageApi.warning("No sponsors available or failed to fetch sponsors");
      }
    } catch (err) {
      console.error("Error fetching sponsors:", err);
      messageApi.error("Failed to fetch sponsors");
    }
  };

  useEffect(() => {
    fetchSponsors()
  }, [])

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const validateImageFormat = (file) => {
    const allowedFormats = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

    // ✅ Handle both raw File and Ant Design file objects
    const fileType = file?.type || file?.originFileObj?.type || '';
    const isValid = allowedFormats.includes(fileType);

    if (!isValid) {
      messageApi.error('Only JPG, JPEG, PNG, or WebP files are allowed!');
    }
    return isValid;
  };

  // Disable past dates for start date
  const disabledStartDate = (current) => {
    // Can not select days before today
    return current && current < dayjs().startOf('day');
  };

  // Disable end dates before start date
  const disabledEndDate = (current) => {
    const startDate = form.getFieldValue('startDate');
    if (!startDate) {
      return current && current < dayjs().startOf('day');
    }
    return current && current < startDate.startOf('day');
  };

  // Validate end date and time
  const validateEndDateTime = (_, value) => {
    const startDate = form.getFieldValue('startDate');
    const startTime = form.getFieldValue('startTime');
    const endDate = form.getFieldValue('endDate');
    const endTime = form.getFieldValue('endTime');

    if (!startDate || !startTime || !endDate || !endTime) {
      return Promise.resolve();
    }

    const startDateTime = startDate
      .hour(startTime.hour())
      .minute(startTime.minute())
      .second(0);

    const endDateTime = endDate
      .hour(endTime.hour())
      .minute(endTime.minute())
      .second(0);

    if (endDateTime.isBefore(startDateTime)) {
      return Promise.reject(new Error('End date and time cannot be before start date and time'));
    }

    return Promise.resolve();
  };


  // Fetch states and cities from API
  const fetchMasterData = async () => {
    try {
      const requestData = {
        requesttable: {
          master_tbl_state: "0",
          master_tbl_city: "0"
        },
        synceddatetime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        FormCode: "201",
        AppVersion: "1.0.0.0",
        ApiKey: "kavin",
        AppTypeNo: "3"
      };

      const response = await api.getMasterDetails(requestData);

      if (response.data.status === "1") {
        const masterData = response.data.response;

        // Map states data
        if (masterData.master_tbl_state && Array.isArray(masterData.master_tbl_state)) {
          const statesData = masterData.master_tbl_state.map(state => ({
            id: state.fld_state_id,
            name: state.fld_state_name,
            fld_rf_id: state.fld_rf_id,
            fld_state_sw_id: state.fld_state_sw_id
          }));
          setStates(statesData);
        }

        // Map cities data
        if (masterData.master_tbl_city && Array.isArray(masterData.master_tbl_city)) {
          const citiesData = masterData.master_tbl_city.map(city => ({
            id: city.fld_city_id,
            name: city.fld_city_name,
            state_id: city.fld_state_id,
            fld_rf_id: city.fld_rf_id,
            fld_city_sw_id: city.fld_city_sw_id
          }));
          setCities(citiesData);
        }
      } else {
        messageApi.error("Failed to fetch master data");
      }
    } catch (error) {
      console.error("Error fetching master data:", error);
      messageApi.error("Error fetching states and cities data");
    }
  };

  useEffect(() => {
    if (visible) {
      fetchMasterData();
    }
  }, [visible]);

  useEffect(() => {
    if (!visible) {
      setTimeout(() => {
        setBannerPreview(null);
        setBannerFileList([]);
        setSponsorSection([]);
        setHostType('1');
        setPriceTier('free');
        setCustomPrice('');
        setEventType('offline');
        hasInitialized.current = false;
      }, 300);
    }
  }, [visible]);




  useEffect(() => {
    if (
      visible &&
      editdata &&
      availableSponsors.length > 0 &&
      !hasInitialized.current
    ) {
      initializeFormData();
      hasInitialized.current = true;
    }
  }, [visible, availableSponsors, editdata]);

  const initializeFormData = () => {
    form.resetFields();

    // Determine pricing type and value
    let pricingType = 'free';
    let customPriceValue = '';

    if (editdata.fld_tier_pricing_name && editdata.fld_tier_pricing_name !== 'Free') {
      pricingType = 'paid';
      // Extract price from string like "₹699/-"
      const priceMatch = editdata.fld_tier_pricing_name.match(/₹(\d+)\/-/);
      if (priceMatch) {
        customPriceValue = priceMatch[1];
      }
    }

    // Set event type
    const eventTypeValue = editdata.fld_event_type_name?.toLowerCase() === "offline" ? "offline" : "online";
    setEventType(eventTypeValue);

    form.setFieldsValue({
      title: editdata.fld_event_title || "",
      eventType: eventTypeValue,
      venue: editdata.fld_venue || "",
      venueUrl: editdata.fld_url || "",
      description: editdata.fld_event_description || "",
      termsandconditions: editdata.fld_terms_conditions || "",
      partnerName: editdata.fld_partner_name || "",
      pricing: pricingType,
      customPrice: customPriceValue,
      capacity: editdata.fld_capacity ? Number(editdata.fld_capacity) : "",
      startDate: editdata.fld_start_date_time ? dayjs(editdata.fld_start_date_time, "DD-MM-YYYY HH:mm:ss") : null,
      startTime: editdata.fld_start_date_time ? dayjs(editdata.fld_start_date_time, "DD-MM-YYYY HH:mm:ss") : null,
      endDate: editdata.fld_end_date_time ? dayjs(editdata.fld_end_date_time, "DD-MM-YYYY HH:mm:ss") : null,
      endTime: editdata.fld_end_date_time ? dayjs(editdata.fld_end_date_time, "DD-MM-YYYY HH:mm:ss") : null,
      hostType: editdata.fld_host_type_id === "2" ? "2" : "1",
      email: editdata.fld_email_id || "",
      phoneNumber: editdata.fld_contact_number || "",
      address: editdata.fld_address || "",
      city: editdata.fld_city_id ? editdata.fld_city_id.toString() : "",
      state: editdata.fld_state_id ? editdata.fld_state_id.toString() : "",
    });

    // ⭐ FIXED: Correct Sponsor Mapping from sponsors_data array
    if (Array.isArray(editdata.sponsors_data) && editdata.sponsors_data.length > 0) {
      // Extract sponsor IDs by matching with available sponsors

      // Find matching sponsor in availableSponsors by name and logo
      const selectedIds = editdata.sponsors_data
        .map(sponsor => {
          const matched = availableSponsors.find(
            s => s.fld_sponsor_name === sponsor.fld_sponsors_name
          );
          return matched ? matched.fld_sponsor_id : null;
        })
        .filter(Boolean);


      // Set sponsor IDs in form
      form.setFieldsValue({
        sponsorIds: selectedIds,
      });
    } else {
      // No sponsors in edit data
      form.setFieldsValue({
        sponsorIds: [],
      });
    }

    setHostType(editdata.fld_host_type_id === "2" ? "2" : "1");
    setPriceTier(pricingType);
    setCustomPrice(customPriceValue);

    initializeBanner();
    initializeSponsors();
  };

  const initializeBanner = () => {
    if (editdata.fld_event_banner_path) {
      const bannerUrl = editdata.fld_event_banner_path;
      setBannerPreview(bannerUrl);
      setBannerFileList([
        {
          uid: "-1",
          name: "banner.jpg",
          status: "done",
          url: bannerUrl,
        },
      ]);
    } else {
      setBannerPreview(null);
      setBannerFileList([]);
    }
  };

  const initializeSponsors = () => {
    let mappedSponsors = [];
    const initialPreviews = {};

    if (Array.isArray(editdata.sponsors_data) && editdata.sponsors_data.length > 0) {
      mappedSponsors = editdata.sponsors_data.map((s, index) => {
        const sponsorLogo = s.fld_sponsors_loge;
        if (sponsorLogo) {
          initialPreviews[index] = sponsorLogo;
        }

        return {
          name: s.fld_sponsors_name || "",
          hyperlink: s.fld_website_url || "",
          fld_child_rf_id: s.fld_child_rf_id || "",
          fileList: sponsorLogo
            ? [
              {
                uid: s?.fld_rf_id || `sponsor-${index}`,
                name: "sponsor.jpg",
                status: "done",
                url: sponsorLogo,
              },
            ]
            : [],
        };
      });
    }


    setSponsorSection(mappedSponsors.length > 0 ? mappedSponsors : []);

    const sponsorFormValues = {};
    mappedSponsors.forEach((sponsor, index) => {
      sponsorFormValues[`sponsorName_${index}`] = sponsor.name;
      sponsorFormValues[`sponsorUrl_${index}`] = sponsor.hyperlink;
    });

    form.setFieldsValue(sponsorFormValues);
  };

  const handleBannerChange = ({ fileList }) => {
    const file = fileList[0];

    if (file) {
      // ✅ Use originFileObj for newly selected files
      const rawFile = file.originFileObj || file;

      if (!validateImageFormat(rawFile)) {
        // ✅ Restore previous banner if editing
        if (editdata?.fld_event_banner_path) {
          setBannerFileList([{
            uid: "-1",
            name: "banner.jpg",
            status: "done",
            url: editdata.fld_event_banner_path,
          }]);
          setBannerPreview(editdata.fld_event_banner_path);
        } else {
          setBannerFileList([]);
          setBannerPreview(null);
        }
        return;
      }

      if (file.originFileObj) {
        getBase64(file.originFileObj).then(setBannerPreview);
      }
    }

    setBannerFileList(fileList.slice(-1));
  };

  const handleEventTypeChange = (e) => {
    const newEventType = e.target.value;
    setEventType(newEventType);

    // Clear location fields when switching to online event
    if (newEventType === 'online') {
      form.setFieldsValue({
        venue: '',
        address: '',
        city: '',
        state: ''
      });
    }
  };

  const handleFinish = async (values) => {
    // setLoading(true);

    //✅ Validate end date and time
    const startDate = values.startDate;
    const startTime = values.startTime;
    const endDate = values.endDate;
    const endTime = values.endTime;

    if (startDate && startTime && endDate && endTime) {
      const startDateTime = startDate.clone()
        .hour(startTime.hour())
        .minute(startTime.minute())
        .second(0);

      const endDateTime = endDate.clone()
        .hour(endTime.hour())
        .minute(endTime.minute())
        .second(0);

      if (endDateTime.isBefore(startDateTime)) {
        messageApi.error('End date and time cannot be before start date and time');
        setLoading(false);
        return;
      }

      // ✅ Store in variables for reuse below
      values._startDateTime = startDateTime;
      values._endDateTime = endDateTime;
    }

    try {
      const formData = new FormData();

      // Basic IDs
      formData.append("fld_rf_id", editdata ? editdata.fld_rf_id : "");
      formData.append("fld_event_sw_id", editdata ? editdata.fld_event_sw_id : "");
      formData.append("fld_event_id", editdata ? editdata.fld_event_id : "");

      // Basic info
      formData.append("fld_event_title", values.title || "");
      formData.append("fld_event_type_id", values.eventType === "offline" ? "1" : "2");
      formData.append("fld_event_type_name", values.eventType === "offline" ? "Offline" : "Online");

      // Banner handling
      const bannerFileObj = bannerFileList[0];
      if (bannerFileObj) {
        if (bannerFileObj.originFileObj) {
          formData.append("fld_event_banner_path", bannerFileObj.originFileObj);
        } else if (bannerFileObj.url) {
          formData.append("fld_event_banner_path", bannerFileObj.url);
        }
      } else if (editdata?.fld_event_banner_path) {
        formData.append("fld_event_banner_path", editdata.fld_event_banner_path);
      } else {
        formData.append("fld_event_banner_path", "");
      }

      // ✅ Fixed Date & Time logic (no key name changes)
      const startDateTime = values._startDateTime || (
        values.startDate && values.startTime
          ? values.startDate.clone()
            .hour(values.startTime.hour())
            .minute(values.startTime.minute())
            .second(0)
          : null
      );

      const endDateTime = values._endDateTime || (
        values.endDate && values.endTime
          ? values.endDate.clone()
            .hour(values.endTime.hour())
            .minute(values.endTime.minute())
            .second(0)
          : null
      );

      if (startDateTime)
        formData.append("fld_start_date_time", startDateTime.format("DD-MM-YYYY HH:mm:ss"));
      if (endDateTime)
        formData.append("fld_end_date_time", endDateTime.format("DD-MM-YYYY HH:mm:ss"));

      // Venue, URL, Description
      formData.append("fld_venue", values.venue || "");
      formData.append("fld_url", values.venueUrl || "");
      formData.append("fld_event_description", values.description || "");
      formData.append("fld_terms_conditions", values.termsandconditions || "");

      // Host Type
      formData.append("fld_host_type_id", hostType.toString());
      formData.append("fld_host_type_name", hostType === "1" ? "KOPA" : "Partner");
      formData.append("fld_partner_name", hostType === "2" ? (values.partnerName || "") : "");

      // Pricing - Updated logic
      let pricingId = "1";
      let pricingName = "Free";

      if (values.pricing === "paid" && values.customPrice) {
        pricingId = "2";
        pricingName = `₹${values.customPrice}/-`;
      }

      formData.append("fld_tier_pricing_id", pricingId);
      formData.append("fld_tier_pricing_name", pricingName);

      formData.append("fld_capacity", values.capacity || "");

      // Contact Information
      formData.append("fld_contact_number", `${values.phoneNumber}` || "");
      formData.append("fld_email_id", values.email || "");

      // Location Information - Only for offline events
      if (values.eventType === "offline") {
        formData.append("fld_address", values.address || "");
        formData.append("fld_city_id", values.city || "");

        const selectedCity = cities.find(c => c.id.toString() === values.city);
        formData.append("fld_city_name", selectedCity ? selectedCity.name : "");

        formData.append("fld_state_id", values.state || "");

        const selectedState = states.find(s => s.id.toString() === values.state);
        formData.append("fld_state_name", selectedState ? selectedState.name : "");
      } else {
        formData.append("fld_address", "");
        formData.append("fld_city_id", "");
        formData.append("fld_city_name", "");
        formData.append("fld_state_id", "");
        formData.append("fld_state_name", "");
      }

      // ⭐ FIXED: Add Sponsors with proper mapping
      if (values.sponsorIds && values.sponsorIds.length > 0) {
        values.sponsorIds.forEach((id) => {
          const sponsor = availableSponsors.find(s => s.fld_sponsor_id === id);

          if (sponsor) {
            // Get child_rf_id from editdata if editing, otherwise empty
            let childRfId = "";
            if (editdata?.sponsors_data) {
              const existingSponsor = editdata.sponsors_data.find(
                s => s.fld_sponsors_name === sponsor.fld_sponsor_name
              );
              childRfId = existingSponsor?.fld_child_rf_id || "";
            }

            // Sponsor Name
            formData.append("fld_child_rf_id[]", childRfId);
            formData.append("fld_sponsors_name[]", sponsor.fld_sponsor_name);

            // Sponsor Website
            formData.append("fld_website_url[]", sponsor.fld_url || "");

            // Sponsor Logo - send URL (backend will handle it)
            formData.append("fld_sponsors_loge[]", sponsor.fld_logo_path || "");
          }
        });
      } else {
        // No sponsors selected
        formData.append("fld_sponsors_name[]", "");
        formData.append("fld_sponsors_loge[]", "");
        formData.append("fld_website_url[]", "");
        formData.append("fld_child_rf_id[]", "");
      }

      // Other Metadata
      if (editdata) {
        formData.append("fld_approved_id", editdata.fld_approved_id || "");
        formData.append("fld_approved_name", editdata.fld_approved_name || "");
      }

      formData.append("fld_post_event_gallery_path", "C:\\Users\\Dell\\Downloads\\step_counter.png");
      formData.append("fld_collaterals_path", "C:\\Users\\Dell\\Downloads\\747b395f236d4362bd5931b0443cba89.xlsx");

      formData.append("fld_geo_x", "");
      formData.append("fld_geo_y", "");
      formData.append("is_full_form_completed_form", "1");

      if (startDateTime)
        formData.append("fld_form_start_time", startDateTime.format("DD-MM-YYYY HH:mm:ss"));
      if (endDateTime)
        formData.append("fld_form_end_time", endDateTime.format("DD-MM-YYYY HH:mm:ss"));

      formData.append("fld_loggedin_user_id", "admin");
      formData.append("data_source", "w");
      formData.append("fld_app_version", 11);

      const apiFn = editdata ? api.eventEdit : api.eventCreation;
      const response = await apiFn(formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.status === "1") {
        setTimeout(() => {
          navigate("/main/events");
        }, 2000);
        setShowSuccessModal(true);
        if (!editdata) {
          form.resetFields();
          setBannerPreview(null);
          setBannerFileList([]);
          setSponsorSection([]);
          setHostType("1");
          setPriceTier("free");
          setCustomPrice("");
          setEventType("offline");
        }
        onSuccess?.();
      }
    } catch (error) {
      console.error("Error updating event:", error);
      messageApi.error("Failed to update event");
    } finally {
      setLoading(false);
    }
  };


  const handleCloseModal = () => {
    setShowSuccessModal(false);
    onClose();
  };

  const handleAddSponsor = () => {
    setSponsorSection([...sponsorSection, { name: "", hyperlink: "", fileList: [] }]);
  };

  const handleSponsorChange = (index, field, value) => {
    const updated = [...sponsorSection];
    updated[index][field] = value;
    setSponsorSection(updated);
  };

  const handleFileChange = (index, fileList) => {
    const file = fileList[0];

    if (file) {
      // ✅ Use originFileObj here too
      const rawFile = file.originFileObj || file;

      if (!validateImageFormat(rawFile)) {
        const updated = [...sponsorSection];
        if (editdata?.sponsors_data?.[index]?.fld_sponsors_loge) {
          updated[index].fileList = [{
            uid: editdata.sponsors_data[index].fld_rf_id || `sponsor-${index}`,
            name: "sponsor.jpg",
            status: "done",
            url: editdata.sponsors_data[index].fld_sponsors_loge,
          }];
        } else {
          updated[index].fileList = [];
        }
        setSponsorSection(updated);
        return;
      }
    }

    const updated = [...sponsorSection];
    updated[index].fileList = fileList;
    setSponsorSection(updated);
  };

  const handleRemoveSponsor = async (index) => {
    const sponsor = sponsorSection[index];

    if (sponsor.fld_child_rf_id) {
      try {
        setLoading(true);
        const deleteData = {
          synceddatetime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          FormCode: "201",
          AppVersion: "1.0.0.0",
          ApiKey: "kavin",
          AppTypeNo: "3",
          fld_child_rf_id: sponsor.fld_child_rf_id
        };

        const response = await api.sponsorDelete(deleteData);

        if (response.data.status === "1") {
          messageApi.success("Sponsor deleted successfully");
          getEventData()

          setSponsorSection(prev => prev.filter((_, i) => i !== index));
        } else {
          messageApi.error("Failed to delete sponsor");
        }
      } catch (error) {
        console.error("Error deleting sponsor:", error);
        messageApi.error("Error deleting sponsor");
      } finally {
        setLoading(false);
      }
    } else {
      setSponsorSection(prev => prev.filter((_, i) => i !== index));
    }
  };

  const handleRemoveBanner = () => {
    setBannerPreview(null);
    setBannerFileList([]);
  };


  const handleCancel = () => {
    form.resetFields();
    setBannerPreview(null);
    setBannerFileList([]);
    setSponsorSection([]);
    setHostType('1');
    setPriceTier('free');
    setCustomPrice('');
    setEventType('offline');
    hasInitialized.current = false;
    onClose();
  };

  return (
    <>
      <Modal
        open={visible}
        onCancel={handleCancel}
        footer={null}
        width="100%"
        style={{ maxWidth: 1100, top: 40 }}
        className="event-form-modal"
        closeIcon={<CloseOutlined style={{ fontSize: '18px', position: 'absolute', top: -8, right: -8 }} />}
      >
        {contextHolder}
        <div className="event-form-container">
          <Card className="event-form-card">
            <div >
              <Title level={3} className="form-title">
                {editdata ? "Edit Event Details" : "Enter New Event Details"}
              </Title>
              <Text className="form-subtitle">
                Fill in the information below to {editdata ? "update" : "create"} your event. All fields marked
                with * are required.
              </Text>
            </div>

            <Form
              layout="vertical"
              form={form}
              onFinish={handleFinish}
              className="event-form"
            >

              <Row gutter={24}>
                {/* Event Title */}
                <Col xs={24} md={12}>

                  <Form.Item
                    name="title"
                    label="Event Title"
                    rules={[{ required: true }]}
                    help="Choose a clear and descriptive title for your event"
                  >
                    <Input placeholder="e.g., Annual Tech Conference 2025" />
                  </Form.Item>


                </Col>
                <Col xs={24} md={12}>
                  {/* Event Type */}
                  <Form.Item
                    label="Event Type"
                    name="eventType"
                    rules={[{ required: true }]}
                    help="Select whether this is an in-person or virtual event"
                  >
                    <Radio.Group onChange={handleEventTypeChange}>
                      <Radio value="offline">Offline Event</Radio>
                      <Radio value="online">Online Event</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>



              {/* Banner Upload */}
              <Form.Item label="Event Banner" help="Recommended: 1200x630px">
                <div
                  style={{
                    height: 200,
                    border: "1px dashed #d9d9d9",
                    borderRadius: 6,
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  {bannerPreview ? (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        overflow: "hidden",
                        cursor: "pointer",
                        position: "relative",
                      }}
                    >
                      <img
                        src={bannerPreview}
                        alt="Banner Preview"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                      {/* Eye & Close buttons */}
                      <div
                        style={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          display: "flex",
                          gap: 8,
                          zIndex: 100,
                          pointerEvents: "auto",
                        }}
                      >
                        <Tooltip title="Preview banner">
                          <Button
                            type="primary"
                            shape="circle"
                            icon={<EyeOutlined />}
                            style={{
                              height: 32,
                              width: 32,
                            }}
                            onClick={() => setBannerModalVisible(true)}
                          />
                        </Tooltip>
                        <Tooltip title="Remove banner">
                          <Button
                            type="primary"
                            shape="circle"
                            icon={<CloseOutlined />}
                            danger
                            style={{
                              height: 32,
                              width: 32,
                            }}
                            onClick={handleRemoveBanner}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  ) : (
                    <Upload.Dragger
                      name="bannerImage"
                      maxCount={1}
                      showUploadList={false}
                      beforeUpload={(file) => {
                        if (!validateImageFormat(file)) return false;
                        getBase64(file).then(setBannerPreview);
                        return false;
                      }}
                      onChange={handleBannerChange}
                      fileList={bannerFileList}
                      style={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        padding: 0,
                        margin: 0,
                        border: "none",
                        background: "none",
                      }}
                    >
                      <div style={{ textAlign: "center" }}>
                        <UploadOutlined style={{ fontSize: 24 }} />
                        <div style={{ marginTop: 8 }}>Click or drag file to upload</div>
                      </div>
                    </Upload.Dragger>
                  )}
                </div>
              </Form.Item>


              {/* Dates and Times */}
              <Row gutter={24}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Start Date"
                    name="startDate"
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      className="w-full"
                      style={{ width: '100%' }}
                      disabledDate={disabledStartDate}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Start Time"
                    name="startTime"
                    rules={[{ required: true }]}
                  >
                    <TimePicker
                      className="w-full"
                      style={{ width: '100%' }}
                      format="h:mm A"
                      use12Hours
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="End Date"
                    name="endDate"
                    rules={[
                      { required: true },
                      { validator: validateEndDateTime }
                    ]}
                  >
                    <DatePicker
                      className="w-full"
                      style={{ width: '100%' }}
                      disabledDate={disabledEndDate}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="End Time"
                    name="endTime"
                    rules={[
                      { required: true }
                    ]}
                  >
                    <TimePicker
                      className="w-full"
                      style={{ width: '100%' }}
                      format="h:mm A"
                      use12Hours
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Rest of the form remains the same */}
              {/* Venue and URL */}
              <Row gutter={24}>
                {eventType === 'offline' && (
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="Venue"
                      name="venue"
                      rules={[{ required: true }]}
                      help="Enter the physical location"
                    >
                      <Input placeholder="e.g., Convention Center Hall A" />
                    </Form.Item>
                  </Col>
                )}
                <Col xs={24} md={eventType === 'offline' ? 12 : 24}>
                  <Form.Item
                    label={eventType === 'offline' ? "Venue URL" : "Meeting Link"}
                    name="venueUrl"
                    rules={[{ required: true }]}
                    help={eventType === 'offline' ? "Optional: Map or meeting link" : "Enter the meeting link for the online event"}
                  >
                    <Input placeholder={eventType === 'offline' ? "e.g., https://maps.google.com/..." : "e.g., https://meet.google.com/abc-def-ghi"} />
                  </Form.Item>
                </Col>
              </Row>

              {/* Location Fields - Only show for offline events */}
              {eventType === 'offline' && (
                <>
                  {/* Address */}
                  <Form.Item
                    label="Address"
                    name="address"
                    rules={[{ required: true }]}
                    help="Enter the complete address"
                  >
                    <Input placeholder="e.g., North Street, Bengaluru" />
                  </Form.Item>

                  {/* State and City */}
                  <Row gutter={24}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="State"
                        name="state"
                        rules={[{ required: true }]}
                        help="Select the state"
                      >
                        <Select placeholder="Select state">
                          {states.map(state => (
                            <Option key={state.id} value={state.id.toString()}>
                              {state.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="City"
                        name="city"
                        rules={[{ required: true }]}
                        help="Select the city"
                      >
                        <Select placeholder="Select city">
                          {cities.map(city => (
                            <Option key={city.id} value={city.id.toString()}>
                              {city.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}

              {/* Email and Phone Number */}
              <Row gutter={24}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      { required: true, message: 'Please enter email' },
                      { type: 'email', message: 'Please enter a valid email' }
                    ]}
                    help="Enter the contact email"
                  >
                    <Input placeholder="e.g., contact@example.com" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Phone Number"
                    name="phoneNumber"
                    rules={[
                      { required: true, message: 'Please enter phone number' },
                      { pattern: /^[0-9]{10}$/, message: 'Please enter a valid 10-digit phone number' }
                    ]}
                    help="Enter the contact phone number"
                  >
                    <Input placeholder="e.g., 9876543210" maxLength={10} />
                  </Form.Item>
                </Col>
              </Row>

              {/* Description */}
              <Form.Item
                label="Description"
                name="description"
                rules={[{ required: true }]}
                help="Provide details of your event, agenda, and expectations"
              >
                <TextArea
                  placeholder="e.g., Join us for an exciting day of learning..."
                  rows={5}
                />
              </Form.Item>

              {/* Host Type & Partner */}
              <Row gutter={24}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Host Type"
                    name="hostType"
                    rules={[{ required: true }]}
                    help="Select whether this event is hosted by KOPA or a partner organization"
                  >
                    <Radio.Group
                      onChange={(e) => setHostType(e.target.value)}
                      value={hostType}
                    >
                      <Radio value="1">KOPA</Radio>
                      <Radio value="2">Partner</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                {hostType === "2" &&
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="Partner Name"
                      name="partnerName"
                      rules={[{ required: true }]}
                      help="If this is a partner event, enter the partner organization name"
                    >
                      <Input placeholder="e.g., Tech Innovators Inc." />
                    </Form.Item>
                  </Col>
                }
              </Row>

              <Row gutter={24}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Pricing"
                    name="pricing"
                    rules={[{ required: true }]}
                    help="Select the ticket type"
                  >
                    <Radio.Group
                      onChange={(e) => {
                        setPriceTier(e.target.value);
                        if (e.target.value === 'free') {
                          form.setFieldValue('customPrice', '');
                        }
                      }}
                      value={priceTier}
                    >
                      <Space size="large">
                        <Radio value="free">Free</Radio>
                        <Radio value="paid" disabled={true}>Paid</Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>

                </Col>

                {/* Custom Price Input */}
                {priceTier === 'paid' && (
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="Ticket Price (₹)"
                      name="customPrice"
                      rules={[{ required: true }]}
                      help="Enter the ticket price in INR"
                    >
                      <InputNumber
                        placeholder="e.g., 699"
                        style={{ width: '100%' }}
                        min={1}
                        formatter={value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/₹\s?|(,*)/g, '')}
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>

              {/* Capacity */}
              <Form.Item
                label="Capacity"
                name="capacity"
                rules={[{ required: true }]}
                help="Maximum number of attendees allowed"
              >
                <InputNumber
                  placeholder="e.g., 500"
                  style={{ width: '100%' }}
                  min={1}
                />
              </Form.Item>

              {/* Description */}
              <Form.Item
                label="Terms and Conditions"
                name="termsandconditions"
                rules={[{ required: true }]}
                help="Include event rules, participant responsibilities, eligibility criteria, cancellation/refund policies, liability disclaimers, and any other important conditions attendees must agree to."
              >
                <TextArea
                  placeholder="e.g., By registering for this event, participants agree to follow all event guidelines. The organizer reserves the right to modify the schedule if necessary. Registration fees are non-refundable after the stated deadline. Participants are responsible for their own belongings and must comply with all venue regulations."
                  rows={5}
                />
              </Form.Item>

              <Form.Item
                name="sponsorIds"
                label="Select Sponsors"
                help="Choose one or more sponsors for this forum."
                rules={[{ required: false }]}
              >
                <Select
                  mode="multiple"
                  placeholder="Select sponsors"
                  optionFilterProp="label"
                  value={form.getFieldValue('sponsorIds')}
                  tagRender={({ label, value, onClose }) => {
                    const sponsor = availableSponsors.find(s => s.fld_sponsor_id === value);
                    return (
                      <Tag closable onClose={onClose} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        {sponsor && (
                          <>
                            <img
                              src={sponsor.fld_logo_path}
                              alt={sponsor.fld_sponsor_name}
                              style={{ width: 16, height: 16, borderRadius: 2 }}
                            />
                            {sponsor.fld_sponsor_name}
                          </>
                        )}
                      </Tag>
                    );
                  }}
                >
                  {availableSponsors.map((sponsor) => (
                    <Select.Option
                      key={sponsor.fld_sponsor_id}
                      value={sponsor.fld_sponsor_id}
                      label={sponsor.fld_sponsor_name}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <img
                          src={sponsor.fld_logo_path}
                          alt={sponsor.fld_sponsor_name}
                          style={{ width: 24, height: 24, borderRadius: 4 }}
                        />
                        {sponsor.fld_sponsor_name}
                      </div>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              {/* Buttons */}
              <Form.Item className="form-actions">
                <Space>
                  <Button size="large" onClick={handleCancel}>
                    Cancel
                  </Button>
                  <Button type="primary" size="large" htmlType="submit" loading={loading} style={{ backgroundColor: "#0072B1" }}>
                    {editdata ? "Update Event" : "Create Event"}
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </Modal>

      {/* Preview Modals */}
      <Modal
        open={bannerModalVisible}
        footer={null}
        onCancel={() => setBannerModalVisible(false)}
      >
        <img src={bannerPreview} alt="Banner" style={{ width: "100%" }} />
      </Modal>



      <SuccessModal
        visible={showSuccessModal}
        onClose={handleCloseModal}
        title={editdata ? "Event data updated successfully" : "Event added successfully"}
        description={editdata ? "Your Event data modified successfully and updated in the system" : "Your event has been successfully created and saved to the system."}
      />
    </>
  );
};

export default Event;